import "../Paragraph/paragraph.scss";
import { Trans } from "react-i18next";
import type { I18NParagraphProps } from "./I18NParagraph.interface";

/**
 * Primary UI component for user interaction
 */
export function I18NParagraph({ id, color, values, className, styles, title, i18n, options, components, children }: I18NParagraphProps) {

	return (<p aria-label={id} id={id} className={[color, className].join(" ")} style={styles} title={title}>
		<Trans i18nKey={i18n} values={values} tOptions={{ ...options }} components={components}>
			{children}
		</Trans>
	</p>);
}
